import { appColors, fontSize, appFonts } from '../../appTheme';
import { StyleSheet } from 'react-native';

export const invitedStaffStyle = StyleSheet.create({
    viewStyle: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    marginValue: {
        marginTop: 10,
    },
    activityView: {
        flex: 1,
        alignItems: 'center',
        justifyContent: 'center'
    },
    flexRow: {
        flexDirection: 'row',
    },
    roleFlex: {
        flex: 0.65
    },
    dateFlex: {
        alignSelf: 'flex-start',
        flex: 0.35
    },
    emailFlex: {
        flex: 0.9,
        marginRight: 10,
    },
    iconFlex: {
        flex: 0.1,
        marginTop: 5
    },
    searchInputStyle: {
        marginRight: '10%',
        fontFamily: appFonts.medium,
        color: appColors.lightDark
    },
    templateText: {
        color: appColors.primary,
        fontFamily: appFonts.bold,
        textAlignVertical: 'center',
        width: '60%'
    },
    subjectHeading: {
        color: appColors.lightFontColor,
        fontFamily: appFonts.bold,
        textTransform: 'uppercase',
    },
    subjectText: {
        color: appColors.lightDark,
        fontFamily: appFonts.medium,
    },
    dropContainerStyle: {
        height: 50,
        marginTop: 15,
    },
    dropStyle: {
        borderWidth: 1,
        paddingHorizontal: 15,
        marginBottom: '5%',
        borderColor: appColors.borderColor,
        color: appColors.lightDark,
    },
    errorText: {
        marginLeft: 5,
        marginTop: 5,
        color: appColors.red,
        fontFamily: appFonts.medium,
    },
    badgeStyle: {
        borderRadius: 40,
        height: 20,
        width: 20,
        backgroundColor: appColors.primary,
        borderWidth: 0,
    },
    badgeContainer: {
        position: 'absolute',
        top: 8,
        right: -2
    },
    badgeText: {
        fontSize: 10,
        fontFamily: appFonts.medium,
        color: appColors.light
    },
    filterStyle: {
        color: appColors.primary,
        textAlign: 'right',
        marginRight: 16,
        fontFamily: appFonts.bold
    },
    filterCard: {
        flexDirection: 'row',
        justifyContent: 'space-between'
    },
    dividerStyle: {
        marginTop: 7,
        marginBottom: 5
    },
    scrollStyle: {
        backgroundColor: appColors.light,
        paddingVertical: 10
    },
    iconRight: {
        marginRight: 8
    },
    borderRadius:
    {
        borderRadius: 8
    },
    alignSpace:
    {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    dateContainerStyle:
    {
        flexDirection: 'row',
        padding: 10,
        alignItems: 'center',
        borderWidth: 1,
        borderColor: appColors.borderColor,
        marginTop: 10,
        marginRight: 5,
        marginLeft: 2,
        justifyContent: 'space-between',

    }

});
